module.exports = __webpack_public_path__ + "img/rendog-4160c9fe-df33-44ec-489e-08d95b7e528f.png";